import React from 'react';
import { Link } from 'react-router-dom';

const sizes = {
  sm: {
    height: 'h-8 sm:h-9'
  },
  md: {
    height: 'h-10 sm:h-11'
  },
  lg: {
    height: 'h-14 sm:h-16'
  }
};

const BrandLockup = ({ to = '/', size = 'md', className = '', as = 'link' }) => {
  const s = sizes[size] || sizes.md;
  const inner = (
    <span className="inline-flex items-center shrink-0">
      <img
        src="/logo-full.png"
        alt="Growmore IT Services"
        className={`${s.height} w-auto object-contain shrink-0 dark:hidden`}
        draggable="false"
      />
      <img
        src="/logo-full-dark.png"
        alt="Growmore IT Services"
        className={`${s.height} w-auto object-contain shrink-0 hidden dark:block`}
        draggable="false"
      />
    </span>
  );

  const cls = `inline-flex items-center group ${className}`;

  if (as === 'div') {
    return <span className={cls}>{inner}</span>;
  }

  return (
    <Link to={to} className={`${cls} hover:opacity-90 smooth-transition`} aria-label="Growmore IT Services">
      {inner}
    </Link>
  );
};

export default BrandLockup;
